// extracted by mini-css-extract-plugin
module.exports = {"tableRows":"LeadReflexReport-module--tableRows--1DmGy","boxShadow":"LeadReflexReport-module--boxShadow--h6kzq","fullScreen":"LeadReflexReport-module--fullScreen--abEBO"};